<template>
	<div
	v-touch:tap="tapHandler"
	@keyup.enter="tapHandler"
	v-touch:swipe.left="swipeLeftHandler"
	v-touch:swipe.right="swipeRightHandler"
	@contextmenu.prevent="contextMenuHandler"
	class="list-group-item clearfix"
	style="user-select: none; cursor: pointer;"
	tabindex="0"
	role="link"
	>

		<button class="btn btn-danger float-right ml-2" v-if="showDeleteBtn" v-touch:tap.stop="deleteTestSession">{{$t('delete')}}</button>

		<div :class="{'float-left': (result.HasPassed != -1)}">
			<p class="mt-0 mb-0">
				<strong>
					{{ result.Code }}:
					{{ result.Name }}
				</strong>
			</p>
			<p class="small mt-0 mb-0">
				<b-icon icon="person" class="mr-1" />
				{{
					isTeacher
						? result.student_displayname
						: result.teacher_displayname
				}}
			</p>
			<p class="small mt-0 mb-0">
				<b-icon icon="clock" class="mr-1" />
				{{ $t('date-taken-colon') }}
				{{ $datetime.getLocaleStringFromTimeStamp(result.DateTaken) }}
			</p>
			<p class="small mt-0 mb-0">
				<b-icon icon="calendar" class="mr-1" />
				{{ $t('created-colon') }}
				{{ $datetime.getLocaleStringFromTimeStamp(result.DateAdded) }}
			</p>
		</div>
		<div class="float-right mt-3" v-if="result.HasPassed != -1 && !showDeleteBtn">
			<LabelIndicator v-if="result.HasPassed === 1" type="success">{{
				getDichotomy('true')
			}}</LabelIndicator>
			<LabelIndicator v-if="result.HasPassed === 0" type="danger">{{
				getDichotomy('false')
			}}</LabelIndicator>
		</div>

	</div>
</template>

<script>
import LabelIndicator from "src/components/LabelIndicator";
export default {
	name: "CompetencyTestSessionWidgetItem",
	props: ['item', 'swipedLeftItem'],
	components: {
		LabelIndicator
	},
	data() {
		return {
		};
	},
	methods: {
		deleteTestSession() {
			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/session/delete`, {
				data: {
					id: this.item.CompetencyTestSessionID
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$emit('removeItem', this.item);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		tapHandler(e) {

			// prevent tap for right clicks
			if(e.button && e.button == 2) {
				return false;
			}

			// go!
			this.$router.push(`/tests/${this.item.CompetencyTestSessionID}`);

		},
		swipeLeftHandler() {
			this.$emit('swipeLeftItem', this.item);
		},
		swipeRightHandler() {
			this.$emit('swipeRightItem', this.item);
		},
		contextMenuHandler() {
			this.$emit('contextMenuItem', this.item);
		},
		getDichotomy(type){
			if(this.$config.getValue('dichotomies') && this.item.dichotomy_id in this.$config.getValue('dichotomies')){
				return this.$config.getValue('dichotomies')[this.item.dichotomy_id][type]
			}
			if(type == 'true'){
				return this.$t('pass');
			}
			if(type == 'false'){
				return this.$t('fail');
			}
		}
	},
	computed: {
		result() {
			return this.item;
		},
		canDelete() {
			// if not marked or assigned teacher or VIEW_ALLTESTS
			return this.item.HasPassed == -1 || this.$UserSession.getValue('id') == this.item.teacher_id || this.$UserSession.hasPriv.call(this, "VIEW_ALLTESTS");
		},
		showDeleteBtn() {
			return (this.swipedLeftItem && this.swipedLeftItem.CompetencyTestSessionID == this.item.CompetencyTestSessionID) && this.canDelete;
		},
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
		isStudent: function() {
			return this.$UserSession.hasPriv.call(this, "APP_STUDENT");
		}
	}
};
</script>
